// PROTOTYPE (hero shapes): the disc as it fills, the story's first breath
// (breaths.js). AVRAH reaches the clients one after another, in the
// order the disc fills, from its hollow outwards: first AVRAH arrives, the
// ones you meet turning white to gold, quickly, as with AVRAH they see you
// too; then it reaches the others, grey to gold, more slowly, the count
// climbing with them. Costellazione then gathers them into AVRAH's mark
// (transitionFrames.js).

export const smooth = (t) => t * t * (3 - 2 * t);

// How much of the fill AVRAH's arrival takes.
const ARRIVAL = 0.2;

// How many of `clients` are gold `fill` (0 to 1) of the way through the
// fill: over the first ARRIVAL of it, the `met` you meet, eased in and out;
// then the others, at an even pace.
export function goldAt({ clients, met }, fill) {
  if (!(fill >= 0 && fill <= 1)) throw new Error(`goldAt: the fill goes from 0 to 1, not ${fill}`);
  if (!(met >= 0 && met <= clients)) throw new Error(`goldAt: you meet from none of the ${clients} clients to all of them, not ${met}`);
  if (fill < ARRIVAL) return Math.round(smooth(fill / ARRIVAL) * met);
  return met + Math.round(((clients - met) * (fill - ARRIVAL)) / (1 - ARRIVAL));
}

// How many see you, as the count says, with `gold` clients gold: the `met`
// you meet, and every other client gold.
export const seenBy = (met, gold) => Math.max(met, gold);

// Each client's colour, in the order the disc fills: the first `gold` gold;
// of the rest, the `met` you meet white, the others the waiting grey. Each
// is always one of the three, never between them. `colours` are the tokens.
export function paletteAt({ met, gold }, colours) {
  return (i) => (i < gold ? colours.lit : i < met ? colours.met : colours.waiting);
}
